import { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "@/i18n";
import App from "./App";
import "./styles/index.css";

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(
  <Suspense fallback="loading">
    <App />
  </Suspense>
);
